import type { FC, JSX } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  type ButtonProps,
} from '@mui/material';

export type Props = {
  title?: string;
  description?: string;
  control: JSX.Element;
  isOpen: boolean;
  isDisableConfirmButton: boolean;
  onConfirm: NonNullable<ButtonProps['onClick']>;
  onClose: NonNullable<ButtonProps['onClick']>;
};

export const TemplateSettingsDialog: FC<Props> = ({
  title,
  description,
  control,
  isOpen,
  isDisableConfirmButton,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm">
      <DialogTitle>{title || t('SettingUpTemplate')}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <DialogContentText color="textPrimary">
          {description || t('FillFieldsBelowToGenerateTemplate')}
        </DialogContentText>
        {control}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onConfirm} disabled={isDisableConfirmButton}>
          {t('DownloadTemplate')}
        </Button>
        <Button variant="outlined" onClick={onClose}>
          {t('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
